import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Home.css';

function Home() {
  const { isAuthenticated } = useAuth();

  const features = [
    {
      icon: '🏠',
      title: 'Flooring',
      description: 'Visualize marble, stone, tile, epoxy, hardwood, and more',
    },
    {
      icon: '🍳',
      title: 'Countertops',
      description: 'Transform kitchens with granite, quartz, marble surfaces',
    },
    {
      icon: '🎨',
      title: 'Interior Paint',
      description: 'Preview any color on your walls before painting',
    },
    {
      icon: '🏡',
      title: 'Exterior Paint',
      description: 'See your home in new colors before committing',
    },
    {
      icon: '✨',
      title: 'Backsplash',
      description: 'Design your perfect kitchen backsplash',
    },
    {
      icon: '🚪',
      title: 'Cabinetry',
      description: 'Visualize new cabinet styles and finishes',
    },
  ];

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Reimagine Your Space with <span className="gradient-text">AI</span>
            </h1>
            <p className="hero-description">
              Upload a photo of your room and instantly visualize new flooring,
              countertops, paint colors, and more. Perfect for contractors and
              homeowners planning renovations.
            </p>
            <div className="hero-actions">
              {isAuthenticated ? (
                <Link to="/generate" className="btn btn-primary btn-lg">
                  Start Designing
                </Link>
              ) : (
                <Link to="/login" className="btn btn-primary btn-lg">
                  Get Started Free
                </Link>
              )}
              <Link to="/pricing" className="btn btn-secondary btn-lg">
                View Pricing
              </Link>
            </div>
          </div>
          <div className="hero-image">
            <div className="hero-preview">
              <div className="preview-before">
                <span className="preview-label">Before</span>
                <img src="/before.jpeg" alt="Room before transformation" className="preview-img" />
              </div>
              <div className="preview-arrow">
                <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M5 12h14M12 5l7 7-7 7"/>
                </svg>
              </div>
              <div className="preview-after">
                <span className="preview-label">After</span>
                <img src="/after.jpg" alt="Room after AI transformation" className="preview-img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Transform Any Space</h2>
          <p className="section-description">
            Our AI can redesign virtually any aspect of your space
          </p>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div key={index} className="feature-card card">
                <span className="feature-icon">{feature.icon}</span>
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3 className="step-title">Upload Your Photo</h3>
              <p className="step-description">
                Take a photo of your room or upload an existing one
              </p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3 className="step-title">Choose Your Style</h3>
              <p className="step-description">
                Select materials, colors, or upload your own reference images
              </p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3 className="step-title">Generate & Compare</h3>
              <p className="step-description">
                AI creates photorealistic renders in seconds
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <div className="cta-content card">
            <h2 className="cta-title">Ready to Transform Your Space?</h2>
            <p className="cta-description">
              Start with just $1 per design. No subscription required.
            </p>
            {isAuthenticated ? (
              <Link to="/generate" className="btn btn-primary btn-lg">
                Create Your First Design
              </Link>
            ) : (
              <Link to="/login" className="btn btn-primary btn-lg">
                Sign Up Now
              </Link>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
